import { gql } from '@apollo/client'

export const SABRE_PACKAGING_FRAGMENT = gql`
  fragment Packaging on Packaging {
    id
    size
    unit
    quantity
    container
    packagingString
  }
`
